import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-filters-panel-head',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './filters-panel-head.component.html',
  styleUrl: './filters-panel-head.component.scss',
})
export class FiltersPanelHeadComponent {
  titleKey = input.required<string>();
  icon = input<string>('filter-search');
  desktopOnly = input(true);
}
